export const environment = {
  //SERVER_URL: `http://192.168.0.88:8047/api/`,
  SERVER_URL: `https://omxcx.pinzhijs.com/api/`,
  production: false,
  useHash: true,
  apiroot: '',
  amap:{
    "key": "fa835f0c796002222a9f1f2153dca099",              // 申请好的Web端开发者Key，首次调用 load 时必填
    "version": "2.0",   // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
    "plugins": ["AMap.MouseTool", "AMap.Geocoder", "AMap.PolyEditor", "AMap.Autocomplete", "AMap.PlaceSearch"],// 需要使用的的插件列表，如比例尺'AMap.Scale'等
  },
  aliyunOSS:{
    use:false,
    region: 'oss-cn-beijing',
    bucket: 'mainuooss',
    accessKeyId: 'LTAI4GHG4ZRi7k3do86SZnT4',
    accessKeySecret: '8hLD0rwatTXQeQv2ReeAz2qI8qivjA'
  }
};
